import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const CreditCardIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 16">
    <path
      d="M18 0H2C0.895 0 0 0.895 0 2V14C0 15.105 0.895 16 2 16H18C19.105 16 20 15.105 20 14V2C20 0.895 19.105 0 18 0ZM5 13H3V11H5V13ZM6 6H3V3H6V6ZM9 13H7V11H9V13ZM13 13H11V11H13V13ZM17 13H15V11H17V13ZM17 6H11V4H17V6Z"
      fill={props.sx?.color || '#B5B7BB'}
    />
  </SvgIcon>
);

CreditCardIcon.propTypes = {
  sx: PropTypes.object,
};

export default CreditCardIcon;
